import _ from 'lodash'
const createId = () => {
    return _.padStart((Math.round(Math.random()*Number.MAX_SAFE_INTEGER))+'', 20, '0');
}

export {createId}